<style scoped>
.event {
	background-color: white;
	border-radius: 4px;

	margin-bottom: 5px;
}

.event_top {
	background-color: #AAAAAA;
	border-radius: 4px 4px 0px 0px;
	width: 100%;
	height: 5px;

}

.event_content {
	padding-left: 15px;	
	padding-right: 15px;	
	padding-top: 5px;	
	padding-bottom: 5px;	
}

</style>

<template>
	<div class="event">
		<div class="event_top"/>
		<v-row 
			class="event_content"
			no-gutters
		>
			<v-col cols="12" class="my-0 text-subtitle-1 text-truncate">
				{{ event.type_desc }}
			</v-col>

			<v-col cols="12" class="mt-0 mb-1 text-caption font-weight-light text-truncate">
				{{ event.description }}
			</v-col>

			<v-col cols="12" class="my-0 text-caption font-weight-light text-truncate" v-if="event.kind">
				<b>Kind: </b>{{ event.kind.code }} - {{ event.kind.display_name }}
			</v-col>

			<v-col cols="12" class="my-0 text-caption font-weight-light text-truncate" v-if="event.job">
				<b>Job: </b>{{ event.job.code }} - {{ event.job.display_name }}
			</v-col>

			<v-col cols="12" class="my-0 text-caption font-weight-light text-truncate" v-if="event.client">
				<b>Client: </b><span v-if="event.client.code != ''">{{ event.client.code }} - </span>{{ event.client.display_name }}
			</v-col>

			<v-col cols="11" class="mt-1 text-caption text-left text-truncate">
				DURATION: {{ format_duration(event.duration) }}
			</v-col>
			<v-col cols="1" class="mt-1 text-caption text-right text-truncate">
			</v-col>

		</v-row>
	</div>
</template>

<script>
export default {
	props: {
		event: {
			type: Object,
			default: null
		}
	},
	methods: {
		format_duration(minutes) {
			if (minutes == 0) {
				return '0h';
			}

			let hours = Math.floor(minutes / 60.0);
			let mins = minutes - (hours * 60.0);

			let fmt = '';
			if (hours > 0) {
				fmt += hours + 'h';
				if (mins > 0) {
					fmt += ' ';
				}
			}

			if (mins > 0) {
				fmt += mins + 'm';
			}

			return fmt;
		}
	}
}
</script>